<template>
    <a-modal title="生成结账单详情" :width="1200" :visible="visible" :confirmLoading="confirmLoading" @cancel="handleCancel">
        <template #footer>
            <a-button type="primary" @click="handleCancel">取消</a-button>
        </template>
        <a-spin :spinning="confirmLoading">
            <s-table
                ref="table"
                :columns="columns"
                :data="loadData"
                :rowKey="(record) => record.orderId + ''" :showPagination="false"
                v-if="play"
            >
                <span slot="checkoutState" slot-scope="text, record">
                    <span :style="record.checkoutState == '已结账' ? 'color:#1890FF':'color:red' ">{{ record.checkoutState }}</span>
                </span>
            </s-table>
        </a-spin>
    </a-modal>
</template>

<script>
import { STable, XDown } from '@/components'
import { baCheckoutExamDetial } from '@/api/modular/interhospital/bacheckoutexam/baCheckoutExamManage'
export default {
    components: {
        STable
    },
    data() {
        return {
            record: {},
            play : true,
            checkoutDateDateString: '',
            visible: false,
            confirmLoading: false,
            form: this.$form.createForm(this),
            loadData: params => {
                return baCheckoutExamDetial(Object.assign(params, this.switchingDate())).then((res) => {
                    return res.data
                })
            },
            queryParam: {
                id : '',
            },
            columns: [
                {
                    title: '患者名称',
                    align: 'center',
                    dataIndex: 'patientName'
                },
                {
                    title: '患者ID',
                    align: 'center',
                    dataIndex: 'patientId'
                },
                {
                    title: '收费单号',
                    align: 'center',
                    dataIndex: 'orderId'
                },
                {
                    title: '收款日期',
                    align: 'center',
                    dataIndex: 'chargeDate'
                },
                {
                    title: '标价金额',
                    align: 'center',
                    dataIndex: 'bjFee',
                },
                {
                    title: '应收金额',
                    align: 'center',
                    dataIndex: 'ysFee',
                },
                {
                    title: '实收金额',
                    align: 'center',
                    dataIndex: 'ssFee',
                },
                // {
                //     title: '其他金额',
                //     align: 'center',
                //     dataIndex: 'otherFee',
                // },
                {
                    title: '收款人',
                    align: 'center',
                    dataIndex: 'chargeUser'
                },
                // {
                //     title: '状态',
                //     align: 'center',
                //     dataIndex: 'state',
                // },
                {
                    title: '结账状态',
                    align: 'center',
                    dataIndex: 'checkoutState',
                    scopedSlots: { customRender: 'checkoutState' },
                },
                {
                    title: '结账类型',
                    align: 'center',
                    dataIndex: 'orderType',
                },
                {
                    title: '开单人',
                    align: 'center',
                    dataIndex: 'drawer',
                },
                {
                    title: '开单科室',
                    align: 'center',
                    dataIndex: 'drawerDept',
                },
            ]
        }
    },
    watch: {
        'visible'(n) {
            if (n == false) {
                setTimeout(() => {
                    this.play = false
                },500)
            } else {
                this.play = true
            }
        }
    },
    methods: {
        // 初始化方法
        add(record) {
            this.visible = true;
            this.record = record;
        },
        switchingDate() {
            this.queryParam.id = this.record.id? this.record.id : ''
            
            const obj = JSON.parse(JSON.stringify(this.queryParam))
            return obj
        },
        
        onChangecheckoutDate(date, dateString) {
            this.checkoutDateDateString = dateString
        },
        handleCancel() {
            this.form.resetFields()
            this.visible = false
        }
    }
}
</script>
